import { render, staticRenderFns } from "./MultipleSpecifications.vue?vue&type=template&id=0db8c610&"
import script from "./MultipleSpecifications.vue?vue&type=script&lang=js&"
export * from "./MultipleSpecifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports